import React from 'react';

const SvgLa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LA_svg__b" fill="#fff">
        <use xlinkHref="#LA_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#LA_svg__a" />
      <path fill="#073A88" mask="url(#LA_svg__b)" d="M0 5.333h28v9.333H0z" />
      <path
        fill="#E2273E"
        mask="url(#LA_svg__b)"
        d="M0 0h28v5.333H0zM0 14.667h28V20H0z"
      />
      <circle fill="#FFF" mask="url(#LA_svg__b)" cx={14} cy={10} r={3.333} />
    </g>
  </svg>
);

export default SvgLa;
